export const states: State[] = [
  { shortName: 'WA', fullName: 'Washington', StateID: 1, OptionNumber: 2 },
  { shortName: 'ID', fullName: 'Idaho', StateID: 2, OptionNumber: 3 },
  { shortName: 'OR', fullName: 'Oregon', StateID: 3, OptionNumber: 4 },
  { shortName: 'AZ', fullName: 'Arizona', StateID: 4, OptionNumber: 5 }
]

export interface State {
  shortName: string;
  fullName: string;
  StateID: number;
  OptionNumber: number;
}